$(function(){
    //CD services slider	
	var flky;
	function checkServiceSlider() {
		if($('.services-i').length && $(window).width() <= 640) {
			flky = new Flickity( '.services-i', {
				autoPlay: true
			});
		}	
		else {
			if(typeof flky !== 'undefined') {
				flky.destroy();
			}
		}
	}
	checkServiceSlider();
	$(window).on('resize', function () {
		checkServiceSlider();
	})

	// CD Mobile footer menu
	$('.Footer__Block--links h2').on('click', function() {
		$(this).toggleClass('menu_active');
		$(this).parents('.Footer__Block--links').find('ul').slideToggle();
	});

	//CD link whatsapp for mobile and desktop
	if($('.lnk_whatsapp').length) {
		var device_attr = 'lnk-desktop';
		if($(window).width() < 768) {
			device_attr = 'lnk-mobile';
		}

		$('.lnk_whatsapp').each(function() {
			$(this).attr("href", $(this).attr(device_attr));
		});
	}
  
  //CD featured video play
  $('.FeatBackVideo .FeatImgPoster button').on('click', function(){
    $(this).parents('.FeatImgPoster').hide();
    $(this).parents('.FeatBackVideo').attr('status','play').find('video').get(0).play();
  });
  
  $('.FeatBackVideo').on('click', function(e){
    if($(e.target).is('.FeatImgPoster button')) return;
    if($(this).attr('status') == 'pause') {
      $(this).find('video').get(0).play();
      $(this).attr('status','play');
    }
    else {
      $(this).find('video').get(0).pause();
      $(this).attr('status','pause');
    }
  });
});

$(document).ready(function(){
  
  function update_cart_info(){
      setTimeout(function(){
        $.ajax({
          url: '/cart.js',
          dataType: "json"
        }).done(function(cart){
      
      
       $('#add-sticky-cart-count').html(cart.item_count);
        $('#add-sticky-cart-price').html(cart.items_subtotal_price / 150 + ' zł');   
      if(cart.items_subtotal_price > 0){
		$('#add-sticky-cart-price').show();
        
        $('#add-sticky-cart-count').addClass('is-visible');
            
      }else{
        $('#add-sticky-cart-price').hide();
        
        $('#add-sticky-cart-count').removeClass('is-visible');
      
      }	
        
        if($('span.dcode-total-value').length){
          
          
          if($('span.dcode-total-value').html() > 150 ){
          	$('.Cart__ShippingNotice.Text--subdued p').html('Jums priklauso nemokamas pristatymas!');
          }else{           
            
          	$('.Cart__ShippingNotice.Text--subdued p').html('Išleiskite  €'+ parseFloat(150 - $('span.dcode-total-value').html()).toFixed(2)  +' papildomai ir gaukite nemokamą pristatymą!')
          }
          
          if($('.Cart__Checkout span[data-money-convertible]').html() != '<span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_total_2" style="display:none !important;"></span>'+$('.dcodeTotal span.dcode-total-value').html()+' zl' ){
         $('.Cart__Checkout span[data-money-convertible]').html('<span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_total_2" style="display:none !important;"></span>'+$('.dcodeTotal span.dcode-total-value').html()+' zl');   
      } 
        
          	$('#add-sticky-cart-price').html($('.dcodeTotal span.dcode-total-value').html()+ ' zł');
          
        }else{
           if(localStorage.getItem('partner_27')){
              $('#add-sticky-cart-price').html( '€'+parseFloat(cart.items_subtotal_price / 100 * 0.73).toFixed(2))

            }
        }
       
    
    
    
    });
      
      },4000)
  }
  
  update_cart_info();
  
  
  $('body').on('click','#sidebar-cart', function(){
      update_cart_info();
  })
  
  
  
  $('#add-sticky-cart').click(function(){
  	window.location = '/cart'
  })
  
  
  $('body').on('click','.add-to-cart',function(){  
  	product_id = $(this).data('handle');  
  	product_sku = $(this).data('sku');  
  	product_price = $(this).data('price');
   
    
      var addData = {
    'id':product_id, 
    'quantity':1
  };
    
    
  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' 
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    if(json.status == 422){
    	$('.add-to-cart[data-handle="'+product_id+'"]').closest('.add-to-cart-box').after('<div class="add-to-cart-error">'+ json.description +'</div>');
      setTimeout(function(){
        $('.add-to-cart-error').remove()
        
      },100000)
    }else{
     	update_cart_info();      
        $.ajax({      
          type: "GET",
          url: '/cart?view=drawer&timestamp=' + Date.now(),
        })
        .done(function(data){  
          $('#sidebar-cart').html($(data).find('form'));
          $('#sidebar-cart').prepend($(data).find('.Drawer__Header')) 
          
          
          
          
        })

        $('#sidebar-cart').attr('aria-hidden','false');
        $('.PageOverlay').addClass('is-visible');
        $('html').addClass('no-scroll');
        $('#sidebar-cart').attr('tabindex',-1);
      
    
    
    }    
    
    
  }).catch(function(err) {
    console.error(err)
  });
  
  })
  
  
  
  $('body').on('click','.Drawer__Close',  function(){
    
     $('#sidebar-cart').attr('aria-hidden','true');
    $('.PageOverlay').removeClass('is-visible');
    $('html').removeClass('no-scroll');
    $('#sidebar-cart').removeAttr('tabindex',-1);
    
  });
  
  
    $('.minigallery img').click(function(){

  	$(this).data('image');
    
    $(this).closest('.ProductItem ').find('.ProductItem__Image[data-image="'+ $(this).data('image') +'"]').addClass('active').removeClass('inactive').siblings('').removeClass('active').addClass('inactive')
  })
  
  
})


var schowane = true;
$(".Description-button").click(function(){
  	//$(".SectionHeader__Description").slideToggle();
  	$(".SectionHeader__Description").toggleClass('active');
    schowane = !schowane;
  	
    if(schowane){
		
        $(".Description-button").text("Rozwiń opis");
    }else{
        $(".Description-button").text("Ukryj opis");
    }
});